import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { LanguageSelect } from '@components/language_select/mod';
import { I18nAndL10n } from '@modules/i18n_and_l10n/mod';
import { ConfigService } from '@services/config.service';
import { LocationSelectorService } from '@services/location_selector.service';
import { UserSettingsService } from '@services/user_settings.service';
import { AuthContextService } from 'Public_old/src/app/Services/authContext.service';
import { GeneralService } from 'Public_old/src/app/Services/general.service';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';
import { sharedResolution } from '../../src/shared_resolution';
import { Root, createRoot } from 'react-dom/client';

const containerElementName = 'reactLanguageSelectComponent';

@Component({
	standalone: false,
	selector: 'language-select-wrapper',
	template: `<div class="wrapper-container" #${containerElementName}></div>`,
	encapsulation: ViewEncapsulation.None,
})
export class LanguageSelectWrapperComponent implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(
		private readonly authContextService: AuthContextService,
		private readonly generalService: GeneralService,
		private readonly ngZone: NgZone,
	) {}

	ngOnChanges(_: SimpleChanges): void {
		this.render();
	}

	ngAfterViewInit(): void {
		this.render();
	}

	ngOnDestroy(): void {
		this.root?.unmount();
	}

	private setLanguage(languageCode: string): void {
		localStorage.setItem('languageCode', languageCode);

		if (this.authContextService.isSignedIn()) {
			this.generalService.setlanguage(languageCode).subscribe(() => {
				window.location.reload();
			});
		} else {
			window.location.reload();
		}
	}

	private async render(): Promise<void> {
		const userSettingsService = sharedResolution.resolve(UserSettingsService);
		const configService = sharedResolution.resolve(ConfigService);
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);

		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const handleLanguageChange = (code: string): void => {
			this.ngZone.run(() => {
				const convertedCode = I18nAndL10n.convertExternalLocaleToAvailableLocale(code as string);

				userSettingsService.updateSettings({ selectedLanguage: convertedCode });
				this.setLanguage(code);
			});
		};

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper>
					<LanguageSelect
						onChange={handleLanguageChange}
						defaultValue={userSettingsService.getSettings().selectedLanguage}
						languages={
							configService.getConfig(locationSelectorService.locationUnitId).languages.map((language) => ({
								code: language.code,
								nativeName: language.nativeName,
								key: language.code,
							})) ?? []
						}
					/>
				</CellulaProviderWrapper>,
			);
		});
	}
}
